var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.35505 2.18661C9.56026 2.18824 9.75949 2.26393 9.91001 2.41445L11.0749 3.5789C11.3969 3.90091 11.3748 4.44345 11.0266 4.79255C10.6775 5.14167 10.1341 5.16243 9.81294 4.84132L8.64848 3.67687C8.32646 3.35574 8.34898 2.81147 8.69724 2.46322C8.88227 2.27773 9.12249 2.18478 9.35505 2.18661ZM7.43573 3.72518L9.76507 6.05408L5.97961 9.83864L3.65027 7.50931L7.43573 3.72518ZM3.04565 7.95036L5.50265 10.4074L2.43041 11.0226L3.04565 7.95036Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElPencilAlt);
export default __webpack_public_path__ + "static/media/el_pencil-alt.8453fc428bdfde254bf81854bcf32400.svg";
export { ForwardRef as ReactComponent };